export default __webpack_public_path__ + "mentioned-by-section.png";